import React from "react";

const CompleteRoIcon = () => {
  return (
    <>
      <svg width="10.445" height="7.756" viewBox="0 0 10.445 7.756">
        <path
          id="Path_2545"
          data-name="Path 2545"
          d="M2.75,7.921,5.525,10.7l5.55-5.946"
          transform="translate(-1.689 -3.69)"
          fill="none"
          stroke="#fff"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
      </svg>
    </>
  );
};

export default CompleteRoIcon;
